import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import timezone from "dayjs/plugin/timezone";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Grid2 } from "@mui/material";
import { Apartment, SaveAlt, TextSnippet } from "@mui/icons-material";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import NotificationToaste from "../global/NotificationToaste";
import dayjs, { utc } from "dayjs";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import DynamicPartConcreteReport from "./DynamicPartConcreteReport";
import { setPostPayload, setPutPayload } from "../../services/api";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ConcreteReport = ({
  data,
  selectedTest,
  loggedUser,
  setOpenReportDialog,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [authUsers, setAuthUsers] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  const [eachTest, setEachTest] = useState({
    serialNo: "AUTO",
    dateOfCast: "",
    dateOfTest: "",
    weight: "",
    concreteMixtureArray: "",
    areaOfCube: "",
    compressiveStrength: "",
  });

  const [mainData, setMainData] = useState({
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    institute: data.institute,
    reference: "",
    sampleLocation: "",
    cement: "",
    grade: "",
    concreteMixture: "",
    areaOfCube: "22500",
    dateOfCast: dayjs(new Date()).format("YYYY-MM-DD"),
    dateOfTest: dayjs(new Date()).format("YYYY-MM-DD"),
    testDays: "",
    labTestsDataFromSubs: [],
    specialNote:
      "The test results reported herein relate to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    remarks: "",
    reportType: "CONC",
    sampleTakenBy: "",
    testedBy: { id: "" },
    reportedBy: loggedUser,
    authorizedBy: null,
    labRequest: data,
    barcode: "",
    labRequestTests: selectedTest,
    referenceReportNumber: "",
    rejectReason: "",
  });

  const concreteMixtureArray = [
    { id: 1, label: "1:3:6 (40.00mm)", value: "15 (C12/15)" },
    { id: 2, label: "1:2.5:5 (25.00mm)", value: "15" },
    { id: 3, label: "1:2:4 (20.00mm)", value: "20 (C16/20)" },
    { id: 4, label: "1:1.5:3 (20.00mm)", value: "25 (C20/25)" },
    { id: 5, label: "1:1:2 (20.00mm)", value: "30 - (C25/30)" },
    { id: 6, label: "Mix Design - C16/20", value: "Mix Design - C16/20" },
    { id: 7, label: "Mix Design - C20/25", value: "Mix Design - C20/25" },
    { id: 8, label: "Mix Design - C25/30", value: "Mix Design - C25/30" },
    { id: 11, label: "Mix Design - C28/35", value: "Mix Design - C28/35" },
    { id: 9, label: "Mix Design - C30/37", value: "Mix Design - C30/37" },
    { id: 21, label: "Mix Design - C32/40", value: "Mix Design - C32/40" },
    { id: 10, label: "Mix Design - C35/45", value: "Mix Design - C35/45" },
    { id: 19, label: "Mix Design - C36/45", value: "Mix Design - C36/45" },
    { id: 18, label: "Mix Design - C55/67", value: "Mix Design - C55/67" },
    { id: 20, label: "Mix Design - C100/115", value: "Mix Design - C100/115" },
    { id: 11, label: "Ready Mix - C16/20", value: "Ready Mix - C16/20" },
    { id: 12, label: "Ready Mix - C20/25", value: "Ready Mix - C20/25" },
    { id: 13, label: "Ready Mix - C25/30", value: "Ready Mix - C25/30" },
    { id: 14, label: "Ready Mix - C28/35", value: "Ready Mix - C28/35" },
    { id: 15, label: "Ready Mix - C30/37", value: "Ready Mix - C30/37" },
    { id: 17, label: "C35/45", value: "C35/45" },
    { id: 16, label: "Ready Mix - C35/45", value: "Ready Mix - C35/45" },
  ];
  //21

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    loadBasicData();
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    console.log("selectedid ", selectedTest.id);
    setLoading(true);

    await axios
      .get(DATA_SAVE_URL + "/api/v1/dataForm/reportData/" + data.id, {
        params: {
          testId: selectedTest.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        console.log("tada", response.data);
        if (response.data.labTestFormData !== null) {
          setUpdate(true);
          setMainData(response.data.labTestFormData);
        } else {
          addCubesToTable();
        }

        setAuthUsers(response.data.authUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const addCubesToTable = () => {
    console.log("data qty " + selectedTest.quantity);
    const newItems = Array.from({ length: selectedTest.quantity }, (_, i) => ({
      serialNo: selectedTest.startingSerialNo + i,
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: mainData.areaOfCube,
      weight: "",
      compressiveStrength: "",
      concreteMixture: mainData.concreteMixture,
    }));
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newItems,
    }));
  };

  const addTestHandle = () => {
    // console.log("added test data ", eachTest);

    const updatedTest = {
      ...eachTest, // or pre if it's based on previous state
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: "22500",
      concreteMixture: mainData.concreteMixture,
    };

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: [...pre.labTestsDataFromSubs, updatedTest],
    }));
  };

  const handleSaveData = async () => {
    if (mainData.testedBy.id === "") {
      setMessage("Select tested by user..!");
      setMessageType("warning");
      setOpen(true);
      return;
    }

    if (!update) {
      setLoading(true);

      const sendObject = {
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: mainData.labTestsDataFromSubs,
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "CONC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: "",
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };
      console.log("main data save sendObject ", sendObject);
      await setPostPayload
        .setPayloadData("/dataForm/saveReport", sendObject)

        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // handleClose();
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
          setOpenReportDialog(false);
        });
    } else {
      setLoading(true);
      // console.log("main data ", mainData);
      setMainData((pre) => ({
        ...pre,
        id: mainData.id,
      }));

      console.log("***asss*********", mainData);

      const sendObject = {
        id: mainData.id,
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: mainData.labTestsDataFromSubs,
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "CONC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: mainData.barcode,
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };

      console.log("************", sendObject);

      await setPutPayload
        .setPayloadData("/dataForm/updateReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 0",
        margin: "0 0 0 0",
      }}
    >
      {mainData.rejectReason === null || mainData.rejectReason === "" ? (
        ""
      ) : (
        <Stack sx={{ width: "100%", marginBottom: "5px" }}>
          <Alert severity="error" width="100%">
            <AlertTitle>This report is rejected.</AlertTitle>
            Reason : {mainData?.rejectReason}
          </Alert>
        </Stack>
      )}

      <Paper
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="COMPRESSIVE STRENGTH TEST" subtitle="GENERAL DATA" />
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={8}>
              <Paper elevation={2} sx={{ padding: "10px" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <TextSnippet />
                      <Typography variant="h5">PROJECT</Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.project}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Apartment />
                      <Typography variant="h5" component="h2">
                        INSTITUTE NAME
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.institute.instituteName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Reference"
                      value={mainData.reference}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          reference: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Sample Locations"
                      value={mainData.sampleLocation}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          sampleLocation: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Report Reference Number"
                      value={mainData.referenceReportNumber}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          referenceReportNumber: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={4}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT NUMBER</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {update
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.id).padStart(4, "0")
                        : "AUTO"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">JOB NO</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {data.year + "/" + String(data.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT DATE</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center" justifyItems="center">
                    <Box sx={{ width: "200px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          sx={{ paddingTop: "8px" }}
                        >
                          <DatePicker
                            label="Date of report"
                            size="small"
                            format="YYYY-MM-DD"
                            timezone="Asia/Colombo"
                            value={
                              mainData.date
                                ? dayjs(mainData.date).tz("Asia/Colombo", true)
                                : dayjs(new Date()).tz("Asia/Colombo", true)
                            }
                            onChange={(newValue) => {
                              const colomboTime = newValue?.tz(
                                "Asia/Colombo",
                                true,
                              );
                              setMainData((pre) => ({
                                ...pre,
                                date: dayjs(colomboTime).format("YYYY-MM-DD"),
                              }));
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Paper
        sx={{ borderRadius: "8px", padding: "10px", width: "100%" }}
        elevation={3}
      >
        <Header
          title="CONCRETE TEST CUBES DATA"
          subtitle="ENTER TESTING DATA"
        />
        <Divider sx={{ margin: "10px 0px 10px 0" }} />
        <DynamicPartConcreteReport
          addTestHandle={addTestHandle}
          eachTest={eachTest}
          mainData={mainData}
          setMainData={setMainData}
          isNonMobile={isNonMobile}
          concreteMixtureArray={concreteMixtureArray}
        />
      </Paper>
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="TEST NOTES" subtitle="AUTHORIZE DATA" />
        <Grid2 container spacing={1} marginTop="10px">
          <Grid2 size={12}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Special Notes"
              value={mainData.specialNote}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  specialNote: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Remarks"
              value={mainData.remarks}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  remarks: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Sample taken / supplied by"
              value={mainData.sampleTakenBy}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  sampleTakenBy: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              select
              label="Tested by"
              fullWidth
              size="small"
              defaultValue=""
              value={mainData.testedBy.id}
              onChange={(e) => {
                e.preventDefault();
                setMainData((pre) => ({
                  ...pre,
                  testedBy: {
                    ...pre.testedBy,
                    id: e.target.value,
                  },
                }));
              }}
            >
              {authUsers.map((data) => (
                <MenuItemMui key={data.id} value={data.id}>
                  {data.firstName + " " + data.lastName}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Divider sx={{ width: "100%" }} />
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              color="secondary"
              loading={loading}
              startIcon={<SaveAlt />}
              variant="contained"
              onClick={handleSaveData}
            >
              Save Data
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default ConcreteReport;
